import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW1301Model } from "../kymw1301.model";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";

// レスポンス構造
export type GetFeatureThemaListResponce = {
  FeatureCode: string;
  FeatureName: string;
}[]

/**
 * 企画書データ出力画面　特集情報を取得するサービス
 * 
 * @export GetFeatureThemaListService
 * @class GetFeatureThemaListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetFeatureThemaListService extends PlessJsonResponderSub<GetFeatureThemaListResponce> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1301Model}
   * @memberof GetFeatureThemaListService
   */
  private model: KYMW1301Model;
  
  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetFeatureThemaListService
   */
  private successFunc: Function;

  constructor(
      protected plessHttp: PlessHttp,
      protected dialogService: PlessDialogServiceSub
    ) {
      super(plessHttp, dialogService);
    }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureThemaListService
   */
  getBody(){
    return new PlessRequest({
      parameter: {
        OrderCodeFrom: this.model.orderCodeFrom,
        OrderCodeTo: this.model.orderCodeTo,
        MediumType: this.model.mediumType,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetFeatureThemaListService
   */
  execute(model: KYMW1301Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getFeatureThemaList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param data 
   * @memberof GetFeatureThemaListService
   */
  success(data: GetFeatureThemaListResponce): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}